import { all, call, fork, put, takeLatest } from 'redux-saga/effects';
import * as ReportingRead from '../../Apis/ReportingReadApi';
import * as Actions from './AdminRecordingsActions';
import { forceLoginIfExpired } from '../Utils/RedirectionUtils';
import Recording from '../../Model/Recording/Recording';
import { RecordingSource } from '../../Utils/Constants';

export function* getAdminRecordingsWatcher() {
  yield takeLatest(Actions.GET_ADMIN_RECORDINGS_REQUEST, getAdminRecordingsWorker);
}

export function* getRecordingCreatorsWatcher() {
  yield takeLatest(Actions.GET_RECORDING_CREATORS_REQUEST, getRecordingCreatorsWorker);
}

export function* getAdminRecordingsWorker(action) {
  try {
    const { fromTime, toTime, limit, accountKey, page, filter, creators } = action.payload;
    const staffKeys = creators.map(creator => creator.staffKey).toString();
    let { data: recordingsData } = yield call(
      ReportingRead.getAdminRecordings,
      accountKey,
      fromTime,
      toTime,
      page,
      limit,
      filter,
      staffKeys
    );
    const { data, ...pagination } = recordingsData;
    pagination.pageCount = Math.ceil(pagination.total / pagination.limit);
    const recordingsList = buildRecordingsList(data);
    yield put({
      type: Actions.GET_ADMIN_RECORDINGS_SUCCESS,
      payload: { recordingsList, pagination }
    });
  } catch (error) {
    yield put({ type: Actions.GET_ADMIN_RECORDINGS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

function buildRecordingsList(recordingsData = []) {
  let recordingsList = [];
  recordingsData.forEach(recording => {
    const { viewCount = 0, title, dateUploaded, recordingKey, size, givenName, surName, email } = recording;

    const recordingBuilder = new Recording.Builder(recordingKey)
      .withTitle(title)
      .withOfflineWebinarKey(recordingKey)
      .withDateUploaded(dateUploaded)
      .withViewCount(viewCount)
      .withShareCount(0)
      .withSize(size)
      .withSource(RecordingSource.G2W)
      .withGivenName(givenName)
      .withSurName(surName)
      .withEmail(email)
      .build();
    recordingsList.push(recordingBuilder);
  });
  return recordingsList;
}

export function* getRecordingCreatorsWorker(action) {
  try {
    let creators = [];
    const { accountKey, fromTime, toTime, page, filter, limit } = action.payload;
    const axiosResponse = yield call(
      ReportingRead.getRecordingCreators,
      accountKey,
      fromTime,
      toTime,
      page,
      filter,
      limit
    );
    const apiBody = axiosResponse.data;
    const { data, ...pagination } = apiBody;
    creators = [...creators, ...data];
    yield put({
      type: Actions.GET_RECORDING_CREATORS_SUCCESS,
      payload: { creators, filter, page, nextPage: pagination.next }
    });
  } catch (error) {
    yield put({ type: Actions.GET_ADMIN_RECORDINGS_FAILURE, error });
    forceLoginIfExpired(error);
  }
}

export default function* rootSaga() {
  yield all([fork(getAdminRecordingsWatcher), fork(getRecordingCreatorsWatcher)]);
}



// WEBPACK FOOTER //
// ./src/Reducks/AdminRecordings/AdminRecordingsSagas.js